import React from 'react';
import { observer } from 'mobx-react';
import { EmptyState, LinkButton, Text } from 'core/components';
import AgentMesh from 'app/views/synthetics/components/mesh/AgentMesh';
import LoadingPanel from './LoadingPanel';

@observer
export default class MeshPanel extends React.Component {
  get emptyFallback() {
    const { test } = this.props;
    const { canShowRawHealth, maxRawLookbackDateRange } = test.results;

    if (canShowRawHealth) {
      return (
        <EmptyState
          pt={1}
          icon="layout-grid"
          title="Aggregate data selected"
          description={
            <Text display="inline-block" maxWidth={475}>
              A network mesh is only available when the selected timeframe is composed of raw data, rather than an
              aggregate data view
            </Text>
          }
          action={
            <LinkButton
              intent="primary"
              text="View the network mesh with raw data from the last supported timeframe"
              onClick={(e) => {
                e.preventDefault();

                // reset the date range which registers and routes a new query hash and triggers a new fetch
                test.results.onDateRangeChange(maxRawLookbackDateRange);
              }}
              minimal
            />
          }
        />
      );
    }

    return null;
  }

  render() {
    const { test } = this.props;
    const {
      healthTimeline,
      mesh,
      resultTimeMs,
      testResultsTaskCount,
      lookbackSeconds,
      startDate,
      endDate,
      hasResults,
      loading,
      displayOptions,
      canShowRawHealth
    } = test.results;

    return (
      <LoadingPanel
        test={test}
        testResults={test.results}
        loading={loading && !hasResults}
        empty={healthTimeline.length === 0 || !hasResults || canShowRawHealth}
        emptyFallback={this.emptyFallback}
      >
        <AgentMesh
          test={test}
          data={mesh}
          resultTimeMs={resultTimeMs}
          lookbackSeconds={lookbackSeconds}
          startDate={startDate}
          endDate={endDate}
          test_id={test.id}
          meshCount={testResultsTaskCount}
          allowAgentDetails={displayOptions.allowAgentDetails}
          mt={1}
          mb={2}
          centered={false}
        />
      </LoadingPanel>
    );
  }
}
